import { Skeleton } from '@mui/material';
import styles from './index.module.css';
import { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import config from '../../skeletonConfig/config.json';

const CoomonSkeleton = (props) => {
  const [theme, setTheme] = useState('');

  useEffect(() => {
    for(let [key, value] of Object.entries(config)) {
      if(window.location.href == key || window.location.href.includes('appType=mobileapp')) setTheme(value)
    }
  }, [theme]);

  switch(theme) {
    case 'theme5':
      return (
        <>
        {!isMobile ?
        (
          <div className={styles.SkeletonMain_Page} >
            <div className={styles.ax_slideparents}>
              <Skeleton variant="rect" width="100%" height={80} style={{ 'marginBottom': '100px' }} />
            </div>
            <div className={styles.searchwidgethome} style={{ 'marginBottom': '80px' }}>
              <div className={styles.searchwidgethometop}>
                <Skeleton variant="rect" width="100%" height={40} />
                <Skeleton variant="rect" width="100%" height={40} />
                <Skeleton variant="rect" width="100%" height={40} />
                <Skeleton variant="rect" width="100%" height={40} />
                <Skeleton variant="rect" width="100%" height={40} />
                <Skeleton variant="rect" width="100%" height={40} />
                <Skeleton variant="rect" width="100%" height={40} />
              </div>
              <div className={styles.searchwidgethomebottom}>
                <div className={styles.searchwidgethomewidget} >
                <Skeleton variant="rect" width="100%" height={20} style={{ 'marginBottom': '10px' }} />
                <Skeleton variant="rect" width="100%" height={20} />
                </div>
                <div className={styles.searchwidgethomewidget} >
                <Skeleton variant="rect" width="100%" height={20} style={{ 'marginBottom': '10px' }} />
                <Skeleton variant="rect" width="100%" height={20} />

                </div>
                <div className={styles.searchwidgethomewidget} >
                <Skeleton variant="rect" width="100%" height={20} style={{ 'marginBottom': '10px' }} />
                <Skeleton variant="rect" width="100%" height={20} />

                </div>
                <div className={styles.searchwidgethomewidget} >
                <Skeleton variant="rect" width="100%" height={60}/>
                </div>
               
             
              </div>
    
    
              {/* <Skeleton variant="rect" width="100%" height={200} /> */}
            </div>
    
            <div className={styles.sixlayout} style={{ 'marginBottom': '40px' }}>
    
              <div className={styles.skeleton} >
                <Skeleton variant="rect" width="380px" height={20} style={{ 'marginBottom': '10px' }} />
                <Skeleton variant="rect" width="300px" height={15} style={{ 'marginBottom': '30px' }} />
              </div>
              <div className={styles.skeletonflex}>
                <Skeleton variant="rect" width="100%" height={300} />
                <Skeleton variant="rect" width="100%" height={300} />
                <Skeleton variant="rect" width="100%" height={300} />
    
              </div>
            </div>
    
    
            <div className={styles.fourlayout} style={{ 'marginBottom': '60px' }}>
    
              <div className={styles.skeleton} >
                <Skeleton variant="rect" width="380px" height={20} style={{ 'marginBottom': '10px' }} />
                <Skeleton variant="rect" width="300px" height={15} style={{ 'marginBottom': '30px' }} />
              </div>
              <div className={styles.skeletonflex}>
                <Skeleton variant="rect" width="100%" height={300} />
                <Skeleton variant="rect" width="100%" height={300} />
                <Skeleton variant="rect" width="100%" height={300} />
                <Skeleton variant="rect" width="100%" height={300} />
              </div>
            </div>
            <div className={styles.threelayout} style={{ 'marginBottom': '60px' }}>
    
              <div className={styles.skeleton} >
                <Skeleton variant="rect" width="380px" height={20} style={{ 'marginBottom': '10px' }} />
                <Skeleton variant="rect" width="300px" height={15} style={{ 'marginBottom': '30px' }} />
              </div>
              <div className={styles.skeletonflex}>
                <Skeleton variant="rect" width="100%" height={150} />
                <Skeleton variant="rect" width="100%" height={150} />
                <Skeleton variant="rect" width="100%" height={150} />
    
              </div>
            </div>
    
            <div className={styles.fivelayout} style={{ 'marginBottom': '40px' }}>
    
              <div className={styles.skeleton} >
                <Skeleton variant="rect" width="380px" height={20} style={{ 'marginBottom': '10px' }} />
                <Skeleton variant="rect" width="300px" height={15} style={{ 'marginBottom': '30px' }} />
              </div>
              <div className={styles.skeletonflex}>
                <Skeleton variant="rect" width="100%" height={300} />
                <Skeleton variant="rect" width="100%" height={300} />
                <Skeleton variant="rect" width="100%" height={300} />
                <Skeleton variant="rect" width="100%" height={300} />
                <Skeleton variant="rect" width="100%" height={300} />
    
              </div>
            </div>
    
    
          </div>
        ): (
          <div className={styles.SkeletonMain_Pagemobile} >
            <div className={styles.ax_slideparents}>
              <Skeleton variant="rect" width="100%" height={65} style={{ 'marginBottom': '20px' }} />
            </div>
          <div className={styles.skeletonflextabwidth}>
          <div className={styles.skeletonflextabmain} style={{ 'marginBottom': '0px' }} >
               <div>
               <div className={styles.skeletonflextab}>
               <Skeleton variant="rect" width="100%" height={45} />
               </div>
               <Skeleton variant="rect" width="60px" height={10} />
               </div>
               <div>
               <div className={styles.skeletonflextab}>
               <Skeleton variant="rect" width="100%" height={45} />
               </div>
               <Skeleton variant="rect" width="60px" height={10} />
               </div>
               <div>
               <div className={styles.skeletonflextab}>
               <Skeleton variant="rect" width="100%" height={45} />
               </div>
               <Skeleton variant="rect" width="60px" height={10} />
               </div>
               <div>
               <div className={styles.skeletonflextab}>
               <Skeleton variant="rect" width="100%" height={45} />
               </div>
               <Skeleton variant="rect" width="60px" height={10} />
               </div>
               <div>
               <div className={styles.skeletonflextab}>
               <Skeleton variant="rect" width="100%" height={45} />
               </div>
               <Skeleton variant="rect" width="60px" height={10} />
               </div>
               <div>
               <div className={styles.skeletonflextab}>
               <Skeleton variant="rect" width="100%" height={45} />
               </div>
               <Skeleton variant="rect" width="60px" height={10} />
               </div>
               <div>
               <div className={styles.skeletonflextab}>
               <Skeleton variant="rect" width="100%" height={45} />
               </div>
               <Skeleton variant="rect" width="60px" height={10} />
               </div>
               
              </div>
          </div>
    
            <div className={styles.searchwidgethome} style={{ 'marginBottom': '30px' }}>
              <div className={styles.searchwidgethometop}>
                <Skeleton variant="rect" width="100%" height={67} style={{ 'marginBottom': '35px' }} />
                <Skeleton variant="rect" width="100%" height={67} style={{ 'marginBottom': '35px' }} />
                <Skeleton variant="rect" width="100%" height={67} style={{ 'marginBottom': '35px' }} />
                <Skeleton variant="rect" width="100%" height={67} style={{ 'marginBottom': '35px' }} />
    
              </div>
    
    
    
              {/* <Skeleton variant="rect" width="100%" height={240} /> */}
            </div>
    
            <div className={styles.sixlayout} style={{ 'marginBottom': '20px' }}>
    
              <div className={styles.skeleton} >
                <Skeleton variant="rect" width="200px" height={20} style={{ 'marginBottom': '10px' }} />
                <Skeleton variant="rect" width="120px" height={15} style={{ 'marginBottom': '30px' }} />
              </div>
              <div className={styles.skeletonflex}>
                <Skeleton variant="rect" width="80%" height={280} />
                <Skeleton variant="rect" width="20%" height={280} />
    
              </div>
            </div>
    
    
            <div className={styles.fourlayout} style={{ 'marginBottom': '20px' }}>
    
              <div className={styles.skeleton} >
              <Skeleton variant="rect" width="200px" height={20} style={{ 'marginBottom': '10px' }} />
              <Skeleton variant="rect" width="120px" height={15} style={{ 'marginBottom': '30px' }} />
              </div>
              <div className={styles.skeletonflex}>
                <Skeleton variant="rect" width="80%" height={150} />
                <Skeleton variant="rect" width="20%" height={150} />
              </div>
            </div>
            <div className={styles.threelayout} style={{ 'marginBottom': '20px' }}>
    
              <div className={styles.skeleton} >
              <Skeleton variant="rect" width="200px" height={20} style={{ 'marginBottom': '10px' }} />
              <Skeleton variant="rect" width="120px" height={15} style={{ 'marginBottom': '30px' }} />
              </div>
              <div className={styles.skeletonflex}>
                <Skeleton variant="rect" width="65%" height={310} />
                <Skeleton variant="rect" width="30%" height={310} />
    
              </div>
            </div>
          </div>
        )}
        </>
      )
    case 'theme10':
      return (
        <>
        {!isMobile ?
        (
          <div>
            <div className={`${styles.SkeletonMain_Page} ${styles.hotel_Page}`} >
            <div className={styles.container}>
              <div className={styles.ax_slideparents}>
                <div className={styles.header__logo}>
                  <Skeleton variant="rect" width="179px" height={51} />
                </div>
                <div className={styles.top_nav}>
                  <Skeleton variant="rect" width="90px" height={15} />
                  <Skeleton variant="rect" width="90px" height={15} />
                  <Skeleton variant="rect" width="90px" height={15} />
                  <Skeleton variant="rect" width="90px" height={15} />
                  <Skeleton variant="rect" width="90px" height={15} />
                  <Skeleton variant="rect" width="90px" height={15} />
                </div>
                <div className={styles.topright_menu}>
                  <Skeleton variant="rect" width="163px" height={17} />
                  <Skeleton variant="rect" width="163px" height={17} />
                  <Skeleton variant="rect" width="143px" height={17} />
                </div>
              </div>
            </div>
            <div className={styles.searchwidgethome}>
              <div className={styles.container}>
                <div className={styles.bannerHeading}>
                  <div className={styles.main_heading}>
                    <Skeleton variant="rect" width="600px" height={70} />
                  </div>
                  <div className={styles.sub_heading}>
                    <Skeleton variant="rect" width="400px" height={25} />
                    <Skeleton variant="rect" width="250px" height={25} />
                  </div>
                  
                </div>
                <div className={styles.searchwidgethometop}>
                  <Skeleton variant="rect" width="142px" height={30} />
                  <Skeleton variant="rect" width="142px" height={30} />
                  <Skeleton variant="rect" width="142px" height={30} />
                </div>
                <div className={styles.searchwidgethomebottom}>
                  <div className={styles.searchwidgethomewidget} >
                    <Skeleton variant="rect" width="330px" height={48} />
                    <Skeleton variant="rect" width="210px" height={48} />
                    <Skeleton variant="rect" width="187px" height={48} />
                    <Skeleton variant="rect" width="187px" height={48} />
                    <Skeleton variant="rect" width="94px" height={48} />
                    <Skeleton variant="rect" width="93px" height={25} />
                    <div className={styles.popular_filters}>
                      <Skeleton variant="rect" width="260px" height={25} />
                      <Skeleton variant="rect" width="257px" height={25} />
                      <Skeleton variant="rect" width="130px" height={25} />
                      <Skeleton variant="rect" width="130px" height={25} />
                      <Skeleton variant="rect" width="130px" height={25} />
                    </div>
                  </div>
                  <div className={styles.searchwidgethomewidget_button} >
                  <Skeleton variant="rect" width="100%" height={88}/>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.sixlayout}>
              <div className={styles.skeleton} >
                <Skeleton variant="rect" width="230px" height={20} />
              </div>
              <div className={styles.skeletonflex}>
                <Skeleton variant="rect" width="372px" height={146} />
                <Skeleton variant="rect" width="372px" height={146} />
              </div>
            </div>
            
    
            <div className={styles.fourlayout}>
              <div className={styles.skeleton} >
                <Skeleton variant="rect" width="380px" height={20}/>
                <Skeleton variant="rect" width="380px" height={15}/>
              </div>
              <div className={styles.skeletonflex}>
                <Skeleton variant="rect" width="100%" height={150} />
                <Skeleton variant="rect" width="100%" height={150} />
              </div>
            </div>
         
            
            <div className={styles.threelayout}>
              <div className={styles.skeletonflex}>
                <Skeleton variant="rect" width="100%" height={180} />
              </div>
            </div>
    
            </div>
          </div>
        ): (
          <div className={`${styles.SkeletonMain_Pagemobile} ${styles.hotel_Page}`} >
            <div className={styles.ax_slideparents}>
              <header className={styles.logo_header}>
                <div className={styles.header__logo}>
                  <div className={styles.menu_icon}>
                    <Skeleton variant="rect" width="20px" height={2} />
                    <Skeleton variant="rect" width="15px" height={2} />
                    <Skeleton variant="rect" width="10px" height={2} />
                  </div>
                  <Skeleton variant="rect" width="138px" height={50} />
                </div>
              </header>
              <div className={styles.notification}>
                <Skeleton variant="rect" width="22px" height={23} />
              </div>  
            </div>
            <div className={styles.welcomeTxt}>
              <Skeleton variant="rect" width="220px" height={12} />
            </div>
            <div className={styles.available_balace}>
              <Skeleton variant="rect" width="220px" height={30} />
            </div>
           <div className={styles.searchwidgethome} >
            
              <div className={styles.searchwidgethometop}>
                <div className={styles.explore_title}>
                  <Skeleton variant="rect" width="60%" height={20} />
                </div>
                <div className={styles.explore_subtitle}>
                  <Skeleton variant="rect" width="100%" height={28} />
                </div>
                <Skeleton variant="rect" width="162px" height={73} />
                <Skeleton variant="rect" width="162px" height={73} />
                <Skeleton variant="rect" width="162px" height={73} />
                <Skeleton variant="rect" width="162px" height={73} />
    
              </div>
    
    
            </div>
            <div className={styles.sixlayout}>
              <div className={styles.skeleton} >
                <Skeleton variant="rect" width="200px" height={20} />
              </div>
              <div className={styles.skeletonflex}>
                <Skeleton variant="rect" width="68px" height={67} />
                <Skeleton variant="rect" width="68px" height={67} />
                <Skeleton variant="rect" width="68px" height={67} />
                <Skeleton variant="rect" width="68px" height={67} />
                <Skeleton variant="rect" width="68px" height={67} />
                <Skeleton variant="rect" width="68px" height={67} />
                <Skeleton variant="rect" width="68px" height={67} />
              </div>
            </div>
          </div>
        )}
        </>
      )
    default:
      break;
  }
}

export default CoomonSkeleton